<template>
  <div style="height: 90vh" @keyup.left="prev()" @keyup.right="next()">
    <!-- <div class="tile is-10 is-vertical is-parent">
      <div class="viewer-wrapper">
        <viewer
          :options="options"
          :images="previewlist"
          @inited="inited"
          class="viewer"
          ref="viewer"
        >
          <template slot-scope="scope">
            <figure class="images">
              <div
                class="image-wrapper"
                v-for="{ source, thumbnail, alt } in scope.images"
                :key="source"
              >
                <img
                  class="image"
                  :src="thumbnail"
                  :data-source="source"
                  :alt="alt"
                />
              </div>
            </figure>
            <p><strong>Options: </strong>{{ scope.options }}</p>
          </template>
        </viewer>
      </div>
    </div> -->
    <!-- <div v-viewer="options" style="height: 100vh"> -->
    <viewer rebuild ref="viewer" :options="options" :images="previewlist" @inited="inited">
      <!-- <template v-for="{ source, thumbnail } in previewlist">
          <img
            :src="thumbnail"
            :data-source="source"
            class="image"
            :key="source"
          />
        </template> -->
      <template>
        <img v-for="{ source, thumbnail } in previewlist" :src="thumbnail" :data-source="source" :key="source"
          class="image" />
      </template>
    </viewer>
    <!-- </div> -->
  </div>
</template>

<script>
import "viewerjs/dist/viewer.css";

export default {
  props: {
    images: Array,
    selectedIndex: Number,
  },
  data() {
    return {
      options: {
        inline: true,
        button: true,
        navbar: true,
        title: false,
        toolbar: {
          zoomIn: { show: true, size: 'large' },
          zoomOut: { show: true, size: 'large' },
          oneToOne: { show: true, size: 'large' },
          reset: { show: true, size: 'large' },
          prev: { show: true, size: 'large' },
          play: {
            show: true,
            size: 'large',
          },
          next: { show: true, size: 'large' },
          rotateLeft: { show: true, size: 'large' },
          rotateRight: { show: true, size: 'large' },
          flipHorizontal: { show: true, size: 'large' },
          flipVertical: { show: true, size: 'large' },
        },
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: false,
        transition: true,
        fullscreen: true,
        keyboard: true,
        url: "data-source",
        initialViewIndex: this.selectedIndex,
      },
      previewlist: [],
    };
  },

  methods: {
    inited(viewer) {
      this.$viewer = viewer;
    },
    readimages() {
      this.previewlist = [];
      this.images.forEach((e) => {
        this.previewlist.push({ thumbnail: e.url, source: e.urlorig });
      });
      this.$viewer.show();
    },
    prev() {
      this.$viewer.prev();
    },
    next() {
      this.$viewer.next();
    },
  },
  mounted() {
    this.readimages();
  },
  watch: {
    images() {
      this.readimages();
    },
    selectedIndex() {
      this.options.initialViewIndex = this.selectedIndex;
    },
  },
};
</script>

<style scoped>
html,
body {
  height: 100%;
}

.images {
  height: 100%;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}

.image {
  z-index: 0;
  width: 200px;
  height: 200px;
}
</style>